import type { FocusNotification } from "@/backend/focus";

export const dedupeNotificationsById = (notifications: FocusNotification[]) => {
  const seenIds = new Set<string>();
  const deduped: FocusNotification[] = [];

  for (const notification of notifications) {
    const notificationId = notification.Notification.Id;

    if (seenIds.has(notificationId)) {
      continue;
    }

    seenIds.add(notificationId);
    deduped.push(notification);
  }

  return deduped.length === notifications.length ? notifications : deduped;
};

export const mergeNotificationsById = (
  currentNotifications: FocusNotification[],
  nextNotifications: FocusNotification[],
) => dedupeNotificationsById([...currentNotifications, ...nextNotifications]);
